// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Tl-z","tupacHeader":"Ul-z","tupacHeader2":"Vl-z","tupacMenu":"Wl-z","tupacMenu2":"Xl-z","tupacMain":"Yl-z","tupacMain2":"Zl-z"};